import { Moment } from 'moment';
import {
  Option,
  booleanOptions,
  tipoSerieOptions,
  negociacaoSecundariaOptions,
  depositariaEmissaoOptions,
  naturezaPessoaOptions,
  tipoDistribuicaoPublicaOptions,
  unidadeFederativaOptions,
  tipoLiquidacaoOptions,
  contraparteRecebedoraOptions,
} from 'common/genericOptions';
import { EmissaoStatus, FluxoMonitor, GarantiaTiposRequest, InvestidorResponse } from 'common/genericTypes';
import { MultaMoraFieldsInterface, multaMoraFieldsInitialState } from 'common/interfaces/MultaMoraFields';
import { typedAction } from 'store/modules/base';

export interface CaracteristicasState extends MultaMoraFieldsInterface {
  // codigoInstrumentoFinanceiro: string;
  id?: string;
  draftId?: string;
  isin: string;
  numeroEmissao: string;
  numeroSerie: string;
  statusEmissao: EmissaoStatus;
  tipoSerie: Option;
  regimeFiduciario: Option;
  coobrigacao: Option;
  distribuicaoPublica: Option;
  tipoDistribuicaoPublica: Option;
  contraparteRecebedora: Option;
  negociacaoSecundariaPor: Option;
  cartulaFormalizado: Option;
  depositariaEmissao: Option;
  utilizacaoAnuncioInicioDistribuicao: Option;
  ufLocalEmissao: Option;
  localEmissao: string;
  dataEncerramentoDistribuicao?: Moment;
  classificadoraRisco1?: string;
  rating1?: string;
  classificadoraRisco2?: string;
  rating2?: string;
  ufLocalPagamento: Option;
  localPagamento: string;
  utilizacaoFaculdadeParagrafo3Art7: Option;
  nomeResponsavelPelasInformacoesDRI: string;
  emailResponsavelPelasInformacoesDRI: string;
  bancoLiquidanteEmissor: string;
  cnpjBancoLiquidanteEmissor: string;
  codigoBancoContaCorrenteVinculadaEmissao: string;
  numeroAgenciaContaCorrenteVinculadaEmissao: string;
  numeroContaCorrenteVinculadaEmissao: string;
  tipoLiquidacao: Option;
  chaveExterna: string;
  descricaoAdicional: string;
  razaoSocialEscriturador: string;
  cnpjEscriturador: string;
  garantias: Array<any>;
  descricaoAdicionalGarantias?: string;
  coordenadoresIds: Array<string>;
  coordenadorLiderId: string;
  razaoSocialAgenteFiduciario: string;
  cpfCnpjAgenteFiduciario: string;
  naturezaAgenteFiduciario: Option;
  cnpjEmissor?: string;
  numeroEmissaoOriginal?: string;
  possuiVasosComunicantes: Option;
}
 
export const caracteristicasInitialState: CaracteristicasState = {
  // codigoInstrumentoFinanceiro: '',
  isin: '',
  numeroEmissao: '',
  numeroSerie: '',
  statusEmissao: '' as EmissaoStatus,
  tipoSerie: tipoSerieOptions[0],
  regimeFiduciario: booleanOptions[0],
  coobrigacao: booleanOptions[0],
  distribuicaoPublica: booleanOptions[1],
  tipoDistribuicaoPublica: tipoDistribuicaoPublicaOptions[0],
  contraparteRecebedora: contraparteRecebedoraOptions[0],
  negociacaoSecundariaPor: negociacaoSecundariaOptions[0],
  cartulaFormalizado: booleanOptions[0],
  depositariaEmissao: depositariaEmissaoOptions[0],
  utilizacaoAnuncioInicioDistribuicao: booleanOptions[1],
  ufLocalEmissao: unidadeFederativaOptions[0],
  localEmissao: '',
  dataEncerramentoDistribuicao: undefined,
  classificadoraRisco1: '',
  rating1: '',
  classificadoraRisco2: '',
  rating2: '',
  ufLocalPagamento: unidadeFederativaOptions[0],
  localPagamento: '',
  utilizacaoFaculdadeParagrafo3Art7: booleanOptions[1], //TODO: verificar oq é isso
  nomeResponsavelPelasInformacoesDRI: '',
  emailResponsavelPelasInformacoesDRI: '',
  bancoLiquidanteEmissor: '',
  cnpjBancoLiquidanteEmissor: '',
  codigoBancoContaCorrenteVinculadaEmissao: '',
  numeroAgenciaContaCorrenteVinculadaEmissao: '',
  numeroContaCorrenteVinculadaEmissao: '',
  tipoLiquidacao: tipoLiquidacaoOptions[0],
  chaveExterna: '',
  descricaoAdicional: '',
  razaoSocialEscriturador: '',
  cnpjEscriturador: '',
  garantias: [],
  descricaoAdicionalGarantias: '',
  coordenadoresIds: [],
  coordenadorLiderId: '',
  razaoSocialAgenteFiduciario: '',
  cpfCnpjAgenteFiduciario: '',
  naturezaAgenteFiduciario: naturezaPessoaOptions[0],
  cnpjEmissor: '',
  numeroEmissaoOriginal: '',
  possuiVasosComunicantes: booleanOptions[1],
  ...multaMoraFieldsInitialState,
};

export interface MetadataState {
  series: Array<Option>;
  negociacoesSecundarias: Array<Option>;
  options: Array<Option>;
  depositariaEmissoes: Array<Option>;
  tipoDistribuicaoPublica: Array<Option>;
  contraparteRecebedora: Array<Option>;
  naturezaPessoa: Array<Option>;
  unidadesFederativas: Array<Option>;
  tiposLiquidacao: Array<Option>;
  investidores: Array<InvestidorResponse>;
  fluxoMonitor: Array<FluxoMonitor>;
}
export const metadataInitialState: MetadataState = {
  series: tipoSerieOptions,
  negociacoesSecundarias: negociacaoSecundariaOptions,
  options: booleanOptions,
  depositariaEmissoes: depositariaEmissaoOptions,
  tipoDistribuicaoPublica: tipoDistribuicaoPublicaOptions,
  contraparteRecebedora: contraparteRecebedoraOptions,
  naturezaPessoa: naturezaPessoaOptions,
  unidadesFederativas: unidadeFederativaOptions,
  tiposLiquidacao: tipoLiquidacaoOptions,
  investidores: [],
  fluxoMonitor: [],
};

interface Field {
  name: keyof CaracteristicasState;
  value: number | string | boolean | undefined | null | Moment | Option | Array<string> | Array<any>;
}

interface MetadataField {
  name: keyof MetadataState;
  value: Array<Option> | Array<InvestidorResponse> | Array<FluxoMonitor>;
}

export const updateMetadata = (field: MetadataField) => {
  return typedAction('notaComercial/metadata/UPDATEFIELD', field);
};

export const resetMetadata = () => {
  return typedAction('notaComercial/metadata/RESET');
};

export const updateField = (field: Field) => {
  return typedAction('notaComercial/caracteristicas/UPDATEFIELD', field);
};

export const resetNotaComercialDetails = () => {
  return typedAction('notaComercial/caracteristicas/RESET');
};

export const updateNotaComercialDetails = (state: CaracteristicasState) => {
  return typedAction('notaComercial/caracteristicas/UPDATE', state);
};

export type CaracteristicasAction = ReturnType<
  | typeof resetMetadata
  | typeof updateMetadata
  | typeof updateField
  | typeof updateNotaComercialDetails
  | typeof resetNotaComercialDetails
>;
